import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Col, Row } from 'react-styled-flexboxgrid';
import ColorPicker from 'shared-assets/components/ColorPicker';
import Label from 'shared-assets/components/Elements/Label';
import InfoIcon from 'shared-assets/components/InfoIcon';
import Input from 'shared-assets/components/Elements/Input';
import Select from 'shared-assets/components/Elements/Select';

// eslint-disable-next-line react/prop-types
const LabelWithInfoIcon = ({ children, helpText, ...props }) => {
  return (
    <Col style={{ paddingLeft: '0' }}>
      <Row className="labelWithInfoIcon" fluid middle="xs" start="xs">
        <Col style={{ paddingRight: '.125rem' }}>
          <Label {...props}>{children}</Label>
        </Col>
        <Col style={{ paddingLeft: '0px' }}>
          <InfoIcon message={helpText} position="left" />
        </Col>
      </Row>
    </Col>
  );
};

const InputGroupStyledWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > label ~ label,
  & > span ~ label,
  & > label ~ div,
  & > label ~ input {
    margin-left: 6px;
  }

  & > label {
    white-space: nowrap;
  }
  & > label ~ label:last-child {
    white-space: pre-wrap;
  }
`;

const InputGroupBlock = props => <div {...props} />;

export default class InputGroup extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    id: PropTypes.string,
    helpText: PropTypes.string,
    inline: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    labelStyle: PropTypes.object,
    name: PropTypes.string,
    required: PropTypes.bool,
    style: PropTypes.object,
    type: PropTypes.oneOf([
      'checkbox',
      'checkboxasradio',
      'color',
      'email',
      'radio',
      'select',
      'text',
      'number',
    ]),
  };

  static defaultProps = {
    children: undefined,
    id: undefined,
    helpText: undefined,
    inline: undefined,
    label: undefined,
    labelStyle: undefined,
    name: undefined,
    required: undefined,
    style: undefined,
    type: 'text',
  };

  render() {
    let {
      helpText,
      id,
      inline,
      label,
      labelStyle,
      name,
      required,
      style,
      type,
      ...rest
    } = this.props;
    if (!label) {
      label = name;
    }
    const inlineFieldTypes = ['checkbox', 'radio', 'checkboxasradio'];
    const typeIsInline = inlineFieldTypes.indexOf(type) !== -1;
    inline = inline === undefined && typeIsInline ? true : inline;

    const InputGroupWrapper = !inline
      ? InputGroupBlock
      : InputGroupStyledWrapper;

    let LabelComponent = Label;
    if (!!helpText) {
      LabelComponent = LabelWithInfoIcon;
    }

    return (
      <InputGroupWrapper style={style}>
        <Choose>
          <When condition={type == 'select'}>
            <LabelComponent
              data-testid="input-group-label"
              htmlFor={id}
              helpText={helpText}
              style={labelStyle}
            >
              {label}
            </LabelComponent>
            <Select
              required={required}
              id={id}
              type={type}
              name={name}
              {...rest}
            />
          </When>
          <When condition={inlineFieldTypes.indexOf(type) !== -1}>
            <Input
              required={required}
              id={id}
              type={type}
              name={name}
              {...rest}
            />
            <LabelComponent
              className={rest.className}
              data-testid="input-group-label"
              helpText={helpText}
              htmlFor={id}
              style={labelStyle}
            >
              {label}
            </LabelComponent>
          </When>
          <When condition={['text', 'email', 'number'].indexOf(type) !== -1}>
            <LabelComponent
              data-testid="input-group-label"
              htmlFor={id}
              helpText={helpText}
              style={labelStyle}
            >
              {label}
            </LabelComponent>
            <Input
              required={required}
              id={id}
              type={type}
              name={name}
              {...rest}
            />
          </When>
          <When condition={['color'].indexOf(type) !== -1}>
            <LabelComponent
              style={labelStyle}
              htmlFor={id}
              data-testid="input-group-label"
              helpText={helpText}
            >
              {label}
            </LabelComponent>
            <ColorPicker {...rest} />
          </When>
        </Choose>
      </InputGroupWrapper>
    );
  }
}
